// src/Pages/Dashboard/Other/ContactUs.jsx
import React, { useState, useEffect } from 'react';
import '../../../../Stylesheets/Dashboard/Other/ContactUs.css';
import { useDispatch, useSelector } from 'react-redux';
import { submitContact, resetContactState } from '../../../../Redux/Others/Support/contactSlice';

const ContactUs = () => {
  const dispatch = useDispatch();
  const { status, error, lastMessage } = useSelector((s) => s.contact);

  const [form, setForm] = useState({
    name: '',
    email: '',
    subject: 'contact',
    message: '',
  });

  useEffect(() => {
    return () => dispatch(resetContactState());
  }, [dispatch]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(submitContact(form)).unwrap().then(() => {
      setForm({ name: '', email: '', subject: 'contact', message: '' });
    });
  };

  return (
    <div className="contact-us-wrapper">
      <div className="contact-us-card">
        <div className="contact-us-info">
          <h2 className="contact-us-title">📨 Contact Us</h2>
          <p className="contact-us-subtext">Have questions, bugs to report, or feature ideas?</p>
          <div className="contact-us-details">
            <p><strong>Email:</strong> support@site360.in</p>
            <p><strong>Phone:</strong> +91-9876543210</p>
            <p><strong>Working Hours:</strong> Mon–Fri, 9AM–6PM</p>
          </div>
        </div>

        <form className="contact-us-form" onSubmit={handleSubmit}>
          <div className="contact-us-grid">
            <div className="contact-us-form-group">
              <label className="contact-us-label">Full Name</label>
              <input
                className="contact-us-input"
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="contact-us-form-group">
              <label className="contact-us-label">Email Address</label>
              <input
                className="contact-us-input"
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="contact-us-form-group contact-us-full-width">
              <label className="contact-us-label">Category</label>
              <select
                className="contact-us-select"
                name="subject"
                value={form.subject}
                onChange={handleChange}
              >
                <option value="contact">General Contact</option>
                <option value="bug">Report a Bug</option>
                <option value="feature">Feature Request</option>
              </select>
            </div>

            <div className="contact-us-form-group contact-us-full-width">
              <label className="contact-us-label">Message</label>
              <textarea
                className="contact-us-textarea"
                name="message"
                rows="4"
                value={form.message}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <button type="submit" className="contact-us-submit-btn" disabled={status === 'loading'}>
            {status === 'loading' ? 'Sending…' : 'Send Message'}
          </button>

          {lastMessage && <p className="contact-us-toast ok">{lastMessage}</p>}
          {status === 'failed' && <p className="contact-us-toast err">{error}</p>}
        </form>
      </div>
    </div>
  );
};

export default ContactUs;
